<template>
  <div class="NewsCenter subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" :issub="false" :active-name="menuName" />
    <!-- 新闻中心 -->
    <div class="sub_contBox" v-if="!ismobile">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 新闻中心 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ name }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 新闻主题 -->
          <div class="news-title-box">
            <span v-for="(item,index) in navList.seminarSubTopics" :key="index" :class="activeName == item.name?'on':''" @click="SwitchTabFn(index,item.id)">{{ item.name }}</span>
          </div>
          <!-- 内容 -->
          <div class="NewsCenter_cont sub_cont">
            <ul>
              <li v-for="(item,index) in newsList" :key="index">
                <router-link :to="{ path: '/newsDetails', query:{ name: menuName, subName: activeName, newsId: item.id, topicId: topicId } }">
                  <div class="mtpic"><img :src="item.imagePath" /></div>
                  <div class="mtdes">
                    <h2 class="Linebreak">{{ item.name }}</h2>
                    <p>{{ item.revisabilityDate }}</p>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <!-- 侧边栏 -->
        <ul class="sidebar">
          <li v-for="(item,index) in navList.seminarSubTopics" :key="index" :class="activeName == item.name?'on':''" @click="SwitchTabFn(index,item.id)">{{ item.name }}</li>
        </ul>
        <!-- 内容 -->
        <div class="content_txt">
          <ul>
            <li v-for="(item,index) in newsList" :key="index">
              <router-link :to="{ path: '/newsDetails', query:{ name: menuName, subName: activeName, newsId: item.id, topicId: topicId } }" target="_blank">
                <div class="mtpic"><img :src="item.imagePath" /></div>
                <div class="mtdes">
                  <h2>{{ item.name }}</h2>
                  <p class="Linebreak-more">{{ item.abstract }}</p>
                </div>
              </router-link>
            </li>
          </ul>
          <!-- 分页器 -->
          <div class="page">
            <Pagination :total='pageTotal' :page="page" :pageSize='pagesize' @currentPage="currentPage"></Pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { NewsCenterApi, NewsCenterListApi, NewsAllApi,AccessRecordsApi } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  import Pagination from '../components/Pagination.vue'
  export default {
    name: "NewsCenter",
    data() {
      return {
        name: '新闻中心',
        ismobile: false,
        activeId: undefined,
        navList: {},
        activeName: '',
        newsList: [],
        pageTotal: 0,
        page: 1,
        pagesize: 5,
        menuName: '',
        topicId: undefined
      }
    },
    created() {
      this.topicId = this.$route.query.topicId;
      this.menuName = this.$route.query.name;
      let wid = window.innerWidth;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
      this.GetNewsCenterFn();
      this.AccessRecordsFn();
    },
    methods: {
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 11
        });
      },
      // tab切换
      SwitchTabFn(i,id) {
        this.activeName = this.navList.seminarSubTopics[i].name;
        this.activeId = id;
        this.page = 1;
        this.NewsCenterListFn();
      },
      // 获取新闻中心menu
      GetNewsCenterFn() {
        NewsCenterApi(
          this.topicId
        ).then(res => {
          this.name = res.name;
          this.navList = res;
          this.activeName = this.$route.query.subName ? this.$route.query.subName : res.seminarSubTopics[0].name;
          for(let i=0;i<res.seminarSubTopics.length;i++){
            if(this.activeName == res.seminarSubTopics[i].name){
              this.activeId = res.seminarSubTopics[i].id;
              this.NewsCenterListFn();
            }
          }
        });
      },
      // 获取新闻中心内容
      NewsCenterListFn() {
        NewsCenterListApi({
            PageSize: this.ismobile ? this.pagesize : 0,
            PageNumber: this.ismobile ? this.page : 0,
            Sorting: 'displayindex desc,revisabilityDate desc'
          },
          this.topicId,
          this.activeId
        ).then(res => {
          this.pageTotal = res.totalCount;
          this.newsList = res.items;
        });
      },
      // 分页器
      currentPage(index) {
        this.page = index;
        this.NewsCenterListFn();
      }
    },
    components: {
      LogoMenu,
      Foot,
      Pagination
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .NewsCenter .content_txt {
      border-top: 1px solid #eaeaea;
      margin-top: 50px;
    }

    .NewsCenter .content_txt ul{
      min-height: 300px;
    }

    .NewsCenter .content_txt li a {
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      border-bottom: 1px dashed #999;
      padding: 20px 0;
    }

    .mtpic {
      width: 180px;
      height: 120px;
      overflow: hidden;
    }

    .mtpic img {
      width: 180px;
      height: 120px;
    }

    .mtdes {
      width: 770px;
    }

    .mtdes h2 {
      font-size: 18px;
      color: #151515;
      text-align: left;
      margin-bottom: 10px;
	  height: 48px;
    }

    .mtdes p {
      font-size: 14px;
      color: #151515;
      line-height: 24px;
      max-height: 72px;
      text-align: left;
      text-indent: 28px;
    }

    .page {
      margin: 60px 0;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .NewsCenter_cont>img {
      width: 100%;
      height: auto;
      max-height: 3rem;
      margin-bottom: .4rem;
    }

    .NewsCenter .NewsCenter_cont {
      margin-bottom: .2rem;
    }

    .content_txt {
      font-size: .28rem !important;
      line-height: .48rem;
      text-align: justify;
    }

    /* 内容 */
    .NewsCenter_cont li a{
      display: flex;
      padding: .3rem 0;
      border-bottom: 1px solid #CCCCCC;
    }

    .NewsCenter_cont li:first-child a{
      padding: 0 0 .3rem;
    }

    .mtpic{
      margin-right: .3rem;
    }

    .NewsCenter_cont li img{
      width: 2.2rem;
      height: 1.4rem;
    }

    .NewsCenter_cont li h2{
      font-size: .32rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: .44rem;
      max-height: 1.32rem;
      color: #000000;
      -webkit-line-clamp: 3 !important;
    }

    .mtdes>p{
      font-size: .28rem;
      line-height: .44rem;
      color: #999999;
      margin-top: .1rem;
      max-height: 1.32rem;
    }

    /* 展开更多 */
    .showMore{
      font-size: .28rem;
      line-height: .48rem;
      color: #1058bb;
      margin: .3rem auto .5rem;
      text-align: center;
    }

    .news-title-box{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
    }

    .news-title-box span{
      display: block;
      text-align: center;
      font-size: .28rem;
      line-height: .48rem;
      width: 33%;
      margin: 0 .5% 0 0;
      border: solid 1px #1058bb;
    }

    .news-title-box span:last-child{
      margin: 0;
    }

    .news-title-box .on{
      background-color: #1058bb;
      color: #FFFFFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/NewsCenter.vue